export default __webpack_public_path__ + "static/media/room3-MASK-tile.b72e6755.png";